import Vue from "vue";
import Vuetify from "vuetify/lib";
import ko from "vuetify/src/locale/ko";
import config from "../configs";
import { ENVIRONMENT } from "@/constants/envs";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  lang: {
    locales: { ko },
    current: "ko",
  },
  rtl: config.theme.isRTL,
  theme: {
    dark: config.theme.globalTheme === "dark",
    themes: {
      dark: config.theme.dark,
      light: config.theme.light,
    },
    options: {
      customProperties: true,
      minifyTheme: function (css) {
        return ENVIRONMENT !== "local" ? css.replace(/[\r|\n]/g, "") : css;
      },
    },
  },
});
